// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3KjMf","col":"styles_col__3nMic"};